import { p as palette } from '../base/color-ec580bc4.js';
import { d as fontSizes, m as mobileFontSizes } from '../base/typography-dd13a6be.js';

const touchLink = {
  backgroundColor: palette.white,
  borderColor: palette.gray[200],
  borderRadius: '8px',
  color: palette.squidInk,
  iconColor: palette.gray[700],
  fontSize: fontSizes.base,
  group: {
    borderColor: palette.gray[200]
  }
};
const mobileTouchLink = {
  mobile: {
    fontSize: mobileFontSizes.base
  }
};

export { mobileTouchLink as m, touchLink as t };
//# sourceMappingURL=touchLink-b41f7d12.js.map
